import React from "react"

export const LoginTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="login-tabs-container">
      <div className="login-tabs">
        <button
          type="button"
          className={`login-tab ${activeTab === "otp" ? "active" : ""}`}
          onClick={() => onTabChange("otp")}
        >
          Login via OTP
        </button>
        <button
          type="button"
          className={`login-tab ${activeTab === "pvs" ? "active" : ""}`}
          onClick={() => onTabChange("pvs")}
        >
          Login via PVS
        </button>
        <div
          className="tab-indicator"
          style={{
            transform:
              activeTab === "pvs" ? "translateX(100%)" : "translateX(0)",
          }}
        />
      </div>
    </div>
  )
}
